import { render, staticRenderFns } from "./GameProjects.vue?vue&type=template&id=748a1ed6&scoped=true"
import script from "./GameProjects.vue?vue&type=script&lang=js"
export * from "./GameProjects.vue?vue&type=script&lang=js"
import style0 from "./GameProjects.vue?vue&type=style&index=0&id=748a1ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a1ed6",
  null
  
)

export default component.exports